import { render, staticRenderFns } from "./OrderLogistics.vue?vue&type=template&id=7ae950a3&scoped=true&"
import script from "./OrderLogistics.vue?vue&type=script&lang=js&"
export * from "./OrderLogistics.vue?vue&type=script&lang=js&"
import style0 from "./OrderLogistics.vue?vue&type=style&index=0&id=7ae950a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae950a3",
  null
  
)

export default component.exports